if (!window.quickSizeBound) {
  window.quickSizeBound = true;

  let lastClickTime = 0;

  document.addEventListener('click', async function(e) {
    const now = Date.now();
    if (now - lastClickTime < 800) return;

    const button = e.target.closest('.quick-size');

    if (!button) return;
    lastClickTime = now;

    const available = button.dataset.available === 'true';

    if (!available) return;

    const variantId = button.dataset.variantId;

    if (!variantId) return;

    const productFormEl = button.closest('product-form');

    if (!productFormEl) return;

    const form = productFormEl.querySelector('.js-product-form');

    if (!form) return;

    const inputId = form.querySelector('input[name="id"]');

    if (!inputId) return;

    /* ===== Loading Start ===== */

    if (button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');

    button.disabled = true;

    const loader = button.querySelector('.cart-item__loader');

    if (loader) {
      loader.hidden = false;
    }

    /* ===== Loading End ===== */

    inputId.value = variantId;

    const clearLoading = () => {
      button.classList.remove('is-loading');

      button.disabled = false;

      if (loader) {
        loader.hidden = true;
      }
    };

    const onAdded = () => {
      productFormEl.removeEventListener('on:cart:add', onAdded);

      productFormEl.removeEventListener('on:cart:error', onError);

      clearLoading();
    };

    const onError = () => {
      productFormEl.removeEventListener('on:cart:add', onAdded);

      productFormEl.removeEventListener('on:cart:error', onError);

      clearLoading();
    };

    productFormEl.addEventListener('on:cart:add', onAdded);

    productFormEl.addEventListener('on:cart:error', onError);

    /* 防止异常一直 loading */

    setTimeout(() => {
      clearLoading();
    }, 5000);

    productFormEl.querySelector('[name="add"]').click();
  });
}

if (!window.mobileQuickSizeBound) {
  window.mobileQuickSizeBound = true;

  document.addEventListener('click', function (e) {

    const btn = e.target.closest('.js-mobile-show-size');

    if (!btn) return;
    btn.style.display = 'none';

    if (window.innerWidth > 768) return;

    const card =
      btn.closest('product-card-image-slider') ||
      btn.closest('.card') ||
      btn.closest('li');

    if (!card) return;

    const quickArea = card.querySelector('.product-card-quick-area');

    if (!quickArea) return;

    quickArea.classList.add('is-active');

    setTimeout(() => {
      quickArea.classList.remove('is-active');

      btn.style.display = '';
    }, 5000);
  });
}
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.search-toggle');
  const search = document.querySelector('.search-popup');

  if (!btn || !search) return;

  btn.addEventListener('click', () => {
    search.classList.toggle('is-active');
  });
});
document.querySelectorAll('.copy-btn').forEach(btn => {

    btn.addEventListener('click', async () => {

        const code = btn.dataset.code;
        const textEl = btn.querySelector('.copy-text');

        try {

        await navigator.clipboard.writeText(code);

        textEl.innerText = 'COPIED';

        btn.classList.add('copied');

        setTimeout(() => {
            textEl.innerText = 'COPY';
            btn.classList.remove('copied');
        }, 1500);

        } catch (err) {
        console.log('copy failed');
        }

    });

});

document.querySelectorAll('.promo-code').forEach(item => {
  item.addEventListener('click', async () => {

    const code = item.dataset.code;

    try {
      await navigator.clipboard.writeText(code);

      const original = item.innerHTML;

      item.innerHTML = `
        <span style="font-weight:600;">Copied!</span>
      `;

      setTimeout(() => {
        item.innerHTML = original;
      }, 1500);

    } catch(err) {
      console.error('Copy failed', err);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {

  const anchorWrapper = document.getElementById('flash-anchor-wrapper');

  if (!anchorWrapper) return;

  const header = document.querySelector('store-header');

  const navLinks = anchorWrapper.querySelectorAll('a');

  let stickyOffset = anchorWrapper.offsetTop;

  function updateSticky() {

    const scrollTop = window.scrollY;

    const headerHeight = header
      ? header.getBoundingClientRect().height
      : 0;

    if (scrollTop >= stickyOffset - headerHeight) {

      anchorWrapper.classList.add('is-sticky');

      anchorWrapper.style.top = `${headerHeight - 2}px`;

    } else {

      anchorWrapper.classList.remove('is-sticky');

      anchorWrapper.style.top = '';

    }
  }

  navLinks.forEach(link => {

    link.addEventListener('click', (e) => {

      e.preventDefault();

      navLinks.forEach(item => {
        item.classList.remove('is-active');
      });

      link.classList.add('is-active');

      const targetId = link.getAttribute('href');

      const target = document.querySelector(targetId);

      if (!target) return;

      const headerHeight = header
        ? header.getBoundingClientRect().height
        : 0;

      const anchorHeight = anchorWrapper.offsetHeight;

      const offset = headerHeight + anchorHeight + 20;

      const targetTop =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;
      console.log(targetTop,"targetTop targetTop ")
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });

    });

  });

  window.addEventListener('scroll', updateSticky);

  window.addEventListener('resize', () => {
    stickyOffset = anchorWrapper.offsetTop;
    updateSticky();
  });

  updateSticky();

});


document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".cc-featured-collection-tab");

  sections.forEach(section => {

    const tabs = section.querySelectorAll(".tab-btn");
    const panels = section.querySelectorAll(".tab-panel");
    const headers = section.querySelectorAll(".tab-header");

    function refreshSlider(panel) {
      const slider = panel.querySelector(".slider, .carousel-slider");
      if (!slider) return;

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));

        if (slider.swiper) slider.swiper.update();
        if (slider.flickity) slider.flickity.resize();
      });
    }

    tabs.forEach(tab => {

      tab.addEventListener("click", () => {

        const id = tab.dataset.tab;

        // tab active
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // panel switch
        panels.forEach(p => {
          const isActive = p.dataset.panel === id;
          p.classList.toggle("active", isActive);

          if (isActive) refreshSlider(p);
        });

        headers.forEach(h => {
          const isActive = h.dataset.header === id;
          h.classList.toggle("hidden", !isActive);
        });

      });

    });

  });

});


document.addEventListener("DOMContentLoaded", function() {
    const minusIcon = "https://cdn.shopify.com/s/files/1/2698/7752/files/Line_1.svg?v=1772611981";
    const plusIcon  = "https://cdn.shopify.com/s/files/1/2698/7752/files/Group_141.svg?v=1772611985";

    const accordions_details = document.querySelectorAll(".leggings-accordion-item");

    accordions_details.forEach(item => {
        const header = item.querySelector(".leggings-accordion-header");
        const iconImg = item.querySelector(".leggings-icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("leggings-active");

            if (item.classList.contains("leggings-active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });

    const accordions_bra = document.querySelectorAll(".accordion-item");

    accordions_bra.forEach(item => {
        const header = item.querySelector(".accordion-header");
        const iconImg = item.querySelector(".icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });

    const accordions_shirt = document.querySelectorAll(".shirt-accordion-item");

    accordions_shirt.forEach(item => {
        const header = item.querySelector(".accordion-header");
        const iconImg = item.querySelector(".icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });


});


(() => {
  const wrapper = document.querySelector('.prime-weekend-countdown');

  if (!wrapper) return;

  const daysEl = wrapper.querySelector('.js-days');
  const hoursEl = wrapper.querySelector('.js-hours');
  const minsEl = wrapper.querySelector('.js-mins');
  const secsEl = wrapper.querySelector('.js-secs');

  // 获取北京时间
  function getChinaTime() {
    const now = new Date();
    const utc = now.getTime() + (now.getTimezoneOffset() * 60000);

    return new Date(utc + (8 * 60 * 60 * 1000));
  }

  // 获取“下周一下午4点”
  function getNextMondayFourPM() {
    const chinaNow = getChinaTime();

    const target = new Date(chinaNow);

    const day = chinaNow.getDay();

    // 距离下周一的天数
    // 周日=0 周一=1
    let daysUntilMonday = (8 - day) % 7;

    // 如果今天就是周一，但已经过了16点，则取下周一
    if (
      day === 1 &&
      chinaNow.getHours() >= 15
    ) {
      daysUntilMonday = 7;
    }

    // 如果今天是周一且还没到16点，则今天16点
    if (
      day === 1 &&
      chinaNow.getHours() < 16
    ) {
      daysUntilMonday = 0;
    }

    target.setDate(chinaNow.getDate() + daysUntilMonday);
    target.setHours(16, 0, 0, 0);

    return target;
  }

  function updateCountdown() {
    const chinaNow = getChinaTime();

    const target = getNextMondayFourPM();

    const diff = target - chinaNow;

    if (diff <= 0) return;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);
    const secs = Math.floor((diff / 1000) % 60);

    daysEl.textContent = String(days).padStart(2, '0');
    hoursEl.textContent = String(hours).padStart(2, '0');
    minsEl.textContent = String(mins).padStart(2, '0');
    secsEl.textContent = String(secs).padStart(2, '0');
  }

  updateCountdown();

  setInterval(updateCountdown, 1000);
})();

document.addEventListener('click', function (e) {

  const drawer = document.getElementById('SizeGuideDrawer');

  // OPEN
  if (e.target.closest('[data-open-size-guide]')) {
    drawer.classList.add('active');

    // ⭐ lock body scroll
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = getScrollbarWidth() + 'px';

    return;
  }

  // CLOSE
  if (
    e.target.closest('.size-guide-drawer__close') ||
    e.target.closest('.size-guide-drawer__overlay')
  ) {
    drawer.classList.remove('active');

    // unlock body scroll
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    return;
  }

  // TAB
  const tab = e.target.closest('.size-guide-tab');

  if (tab) {

    const target = tab.dataset.tab;

    document.querySelectorAll('.size-guide-tab')
      .forEach(item => item.classList.remove('active'));

    document.querySelectorAll('.size-guide-content')
      .forEach(item => item.classList.remove('active'));

    tab.classList.add('active');

    const content = document.querySelector(`[data-content="${target}"]`);
    content?.classList.add('active');

    // ⭐ FIX：切 tab 后重置滚动位置（关键）
    const scrollBox = content?.querySelector('.size-guide-table-scroll');
    if (scrollBox) {
      scrollBox.scrollTop = 0;
      scrollBox.scrollLeft = 0;
    }
  }
});


// 计算滚动条宽度（防抖动）
function getScrollbarWidth() {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  div.style.width = '100px';
  document.body.appendChild(div);

  const width = div.offsetWidth - div.clientWidth;
  div.remove();

  return width;
}